




















































import Vue from 'vue';
import _ from 'lodash';
import store from '@/store';
import { mapState, mapGetters } from 'vuex';
import { ViewpointDao } from "@/api/ViewpointDao";
import TeamCreate from '@/components/team/team-create.vue';
import TeamResults from '@/components/team/teams-results.vue';
import TeamCardMenu from '@/components/team/teams-card-menu.vue';
import TeamInviteButton from '@/components/team/team-invite-button.vue';
import TeamViewpointButton from '@/components/team/team-viewpoint-button.vue';
import ViewpointViewer from '@/components/common/viewpoint-viewer.vue';

var apiDao: ViewpointDao = new ViewpointDao();

export default Vue.extend({

  name: 'TeamViewpoints',

  components: {
    'team-create': TeamCreate,
    'team-results': TeamResults,
    'team-card-menu': TeamCardMenu,
    'team-invite-button': TeamInviteButton,
    'team-viewpoint-button': TeamViewpointButton,
    ViewpointViewer,
  },

  props: {
    teamProp: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      team: this.teamProp,
      sourceViewpointId: '',
      targetViewpointId: '',
      sharedViewpoints: [] as any,
      myViewpoints: [] as any,
      valid: false,
      compare: true,
      forceUpdate: 0,
      message: 'Your team is being created ...',
      showMessage: false,
      formSubject: '' as any,
      ruleSubject: [
        (v: any) => !!v || '"Team Name" is required',
        (v: any) =>
          (v && v.length <= 100) ||
          '"Team Name" must be less than 100 characters'
      ],
      formBody: '' as any,
      ruleBody: [
        // (v: any) => !!v || '"Description" is required',
        (v: any) =>
          ( !v || (v.length <= 500)) ||
          '"Description" must be less than 500 characters'
      ],
    };
  },

  created() {
    console.log('[ TeamViewpoints created() ]');
    this.loadViewpoints();
  },

  mounted() {
  },

  watch: {
    teamProp(newVal, oldVal) {
      console.log('Watch > Watch > Store > Teams > teamProp');
      this.team = newVal;
      this.loadViewpoints();
    },
    getVpGroups(newVal, oldVal) {
      console.log('Watch > Store > Teams > getVpGroups');
      this.loadViewpoints();
    },
    getVpInstances(newVal, oldVal) {
      console.log('Watch > Store > Viewpoints > getVpInstances');
      this.loadViewpoints();
    },
    getVpGroupInstances(newVal, oldVal) {
      console.log('Watch > Store > Viewpoints > getVpGroupInstances');
      this.loadViewpoints();
      this.forceUpdate++;
    },
  },

  computed: {
    
     ...mapGetters([
      'getFavourites',
      'getIsLoggedIn',
      'getInstanceId',
      'getVpInstances',
      'getVpInstancesCount',
      'getVpInstanceList',
      'getVpInstanceListCount',
      'getVpGroups',
      'getVpGroupsCount',
      'getVpGroupsList',
      'getVpGroupsListCount',
      'getVpGroupInstances',
      'getVpGroupInstancesCount',
      'getVpGroupInstancesList',
      'getVpGroupInstancesListCount'
    ]),
   
    isLoggedIn(): any {
      return this.$store.getters.getIsLoggedIn;
    },

    formatDate(): string {
      let newDate: Date = new Date
      let options: object = { year: 'numeric', month: 'long', day: 'numeric' };
      let locale: string = 'en-US';
      return newDate.toLocaleDateString(locale, options);
    },

    teamName(): string {
      if (Object.keys(this.team).length){
        let name: string  = ( this.team.name ? String(this.team.name) : '' );
        let res: string = ( name.length > 8 ? String(name.substring(0, 8)) + '...' : String(name) );
        return res;
      } else {
        return '';
      }
    },

    numberOfTeamMembers(): number {
      if (Object.keys(this.team).length){
        return this.team.users.length + this.team.adminUsers.length;
      } else {
        return 0;
      }
    },

    numberOfSharedViewpoints(): number {
      if (Object.keys(this.team).length){
        return this.team.viewpoints.length;
      } else {
        return 0;
      }
    },

    isValidEdit(): boolean {
      return (this.valid && !!this.formSubject);
    },

    isTeamLoaded(): boolean {
      return !!Object.keys(this.team).length;
    },

  },

  methods: {

    loadViewpoints() {
      if (this.numberOfSharedViewpoints) {
        const allMySharedViewpoints: any = this.getVpGroupInstances;
        const teamViewpointIds: any = this.team.viewpoints;
        const sharedViewpoints: any[] = _.filter(allMySharedViewpoints, (e: any) => { return teamViewpointIds.includes(e.viewpointId) });
        this.sharedViewpoints = _.orderBy(sharedViewpoints, [ (viewpoint: any) => { return viewpoint.name } ], ['asc']);
        console.log('[ loadViewpoints() > sharedViewpoints(' + this.numberOfSharedViewpoints + '): ]');
        console.log(this.sharedViewpoints);
      }
      const myViewpoints = this.getVpInstances;
      this.myViewpoints = _.orderBy(myViewpoints, [ (viewpoint: any) => { return viewpoint.name } ], ['asc']);
    },
    
  },


});

